/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.wrapper[_ngcontent-%COMP%]{width:100%;height:100%;min-height:100%;display:block;position:relative;background-color:#f5f7fa}"];
export { styles as styles };
